export default __webpack_public_path__ + "static/media/DSC_0510.3ef2509e.webp";